export default "__VITE_ASSET__CFEsF7bC__"